import { IconButton, IconButtonProps, Theme, Typography, createStyles, makeStyles } from '@forgeglobal/design-framework'
import { StyleDefaults } from 'isolated-design-library'
import React from 'react'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    iconBtn: {
      border: StyleDefaults.border,
      borderRadius: StyleDefaults.borderRadius,
      height: theme.spacing(5),
    },
    typographyRoot: {
      color: StyleDefaults.color.light,
    },
  })
)

const SecondaryIconButton: React.FC<IconButtonProps> = ({ children, ...rest }) => {
  const classes = useStyles()
  return (
    <IconButton className={classes.iconBtn} {...rest}>
      <Typography variant="h5" className={classes.typographyRoot}>
        {children}
      </Typography>
    </IconButton>
  )
}

export { SecondaryIconButton }
